import { defineStore } from 'pinia'
import MOTDApi from '@/api/MOTD'
import { useUserStore } from '@/stores/user'

const LAST_SHOWN_HASH_KEY = 'motd_last_shown_hash'
const POLL_INTERVAL = 5 * 60 * 1000 // 5 minutes

export const useMOTDStore = defineStore('motd', {
  state: () => ({
    currentMOTD: null,
    showToast: false,
    pollInterval: null,
    loading: false
  }),

  getters: {
    hasActiveMOTD: (state) => !!state.currentMOTD,
    shouldShowToast: (state) => {
      if (!state.currentMOTD) return false

      const lastShownHash = localStorage.getItem(LAST_SHOWN_HASH_KEY)
      return state.currentMOTD.hash !== lastShownHash
    }
  },

  actions: {
    async fetchMOTD() {
      // Only fetch MOTD if user is logged in
      const userStore = useUserStore()
      if (!userStore.loggedIn) {
        return
      }

      this.loading = true
      try {
        const response = await MOTDApi.getMOTD()
        if (response.status === 'success' && response.data) {
          const newHash = response.data.hash
          const lastShownHash = localStorage.getItem(LAST_SHOWN_HASH_KEY)

          this.currentMOTD = response.data

          // Show toast only if hash differs from last shown
          if (newHash !== lastShownHash) {
            this.showToast = true
          }
        } else {
          this.currentMOTD = null
          this.showToast = false
        }
      } catch (error) {
        console.error('Failed to fetch MOTD:', error)
        this.currentMOTD = null
        this.showToast = false
      } finally {
        this.loading = false
      }
    },

    markAsShown() {
      if (this.currentMOTD && this.currentMOTD.hash) {
        localStorage.setItem(LAST_SHOWN_HASH_KEY, this.currentMOTD.hash)
        this.showToast = false
      }
    },

    startPolling() {
      // Only start polling if user is logged in
      const userStore = useUserStore()
      if (!userStore.loggedIn) {
        return
      }

      // Initial fetch
      this.fetchMOTD()

      // Set up polling every 5 minutes
      if (!this.pollInterval) {
        this.pollInterval = setInterval(() => {
          this.fetchMOTD()
        }, POLL_INTERVAL)
      }
    },

    stopPolling() {
      if (this.pollInterval) {
        clearInterval(this.pollInterval)
        this.pollInterval = null
      }
    }
  }
})
